import {addFilter} from '@wordpress/hooks';

/**
 * For a free trial with nothing due today, Apple Pay's payment sheet still needs to show the
 * subscription's recurring total - not the live $0 total - since the server creates/authorizes
 * the PayPal order for that same recurring amount purely to vault the payment method (see
 * SubscriptionController::maybe_authorize_order_for_vaulting()). PayPal rejects the payment if
 * the amount the buyer authorized in the wallet doesn't match the order it's confirming.
 *
 * recurringTotal is exposed at the top level via wc_ppcp_cart_data ->
 * SubscriptionController::add_recurring_total_to_cart_data() - reused as-is by CartShipping's
 * response for the shipping-selection callbacks, and by ApplePay.js's `settings` (spread from
 * cartData.extensions.wc_ppcp.cart) for the initial payment request, since createSession() runs
 * before any shipping interaction/API response exists yet.
 */
const useRecurringTotal = (data, response) => {
    const recurringTotal = response?.recurringTotal || 0;
    if (recurringTotal && data.total) {
        data.total.amount = recurringTotal;
    }
    if (recurringTotal && data.newTotal) {
        data.newTotal.amount = recurringTotal;
    }
    return data;
};

addFilter('applepay_blocks_payment_request', 'wc-ppcp/subscriptions', useRecurringTotal);
addFilter('applepay_blocks_complete_shipping_method_selection', 'wc-ppcp/subscriptions', useRecurringTotal);
addFilter('applepay_blocks_complete_shipping_contact_selection', 'wc-ppcp/subscriptions', useRecurringTotal);